module.exports = __webpack_public_path__ + "img/open-box.4f6eb388.svg";